import classNames from 'classnames';
import type { LimitSectionProps } from 'components/secondaryMarket/limitOrder/sections/LimitSection.connect';
import { VerticalFormGroup } from 'components/secondaryMarket/shared';
import { Block } from 'components/secondaryMarket/shared/Blocks/Block';
import { AmountWithUnit } from 'components/shared/Amount/Amount';
import { useTrend } from 'hooks/useTrend';

const fieldIds: string[] = ['limit', 'salesMarginAdjustment'];
export function LimitSection({
  clientLimit,
  salesMarginAdjustmentChanged,
  clientLimitChanged,
  salesMarginAdjustment,
  isFrozen,
  className,
  priceType,
  currency,
  streamingPrice,
}: LimitSectionProps) {
  const unit = priceType === 'Percent' ? '%' : currency;
  const priceClassName = useTrend(streamingPrice?.settlementPrice);
  const statusMessage = streamingPrice?.quoteStatus === true ? 'On' : 'Off';
  const statusClassName = streamingPrice?.quoteStatus === true ? 'bg-success' : 'bg-danger';
  return (
    <Block className={className} label="secondaryMarket.limit.label.limit" id="limit" fieldIds={fieldIds}>
      <div>
        <div className="row">
          <VerticalFormGroup inputId="limit" label="secondaryMarket.limit.label.clientLimit" className="col-md-6">
            <AmountWithUnit
              onChange={clientLimitChanged}
              e2e="clientLimit"
              incrementStep={1}
              unit={unit}
              value={clientLimit}
              precision={2}
              isDisabled={isFrozen}
              tabIndex={1}
            />
          </VerticalFormGroup>
          <VerticalFormGroup
            inputId="salesMarginAdjustment"
            label="secondaryMarket.limit.label.salesMarginAdjustment"
            className="col-md-6"
          >
            <AmountWithUnit
              value={salesMarginAdjustment}
              onChange={salesMarginAdjustmentChanged}
              e2e="salesMarginAdjustment"
              incrementStep={1}
              unit={unit}
              isDisabled={isFrozen}
              precision={2}
              tabIndex={4}
            />
          </VerticalFormGroup>
        </div>
        {streamingPrice && (
          <div className="row align-items-end">
            <VerticalFormGroup inputId="price" label="secondaryMarket.limit.label.price" className="col">
              <AmountWithUnit
                e2e="price"
                className={priceClassName}
                unit={unit}
                value={streamingPrice?.settlementPrice?.value!}
                precision={2}
                isReadOnly
                appendedChildren={
                  <span className={classNames('input-group-text bg-opacity-25 p-2', statusClassName)}>
                    {statusMessage}
                  </span>
                }
                tabIndex={1}
              />
            </VerticalFormGroup>
            <VerticalFormGroup inputId="salesMargin" label="secondaryMarket.limit.label.salesMargin" className="col">
              <AmountWithUnit
                e2e="salesMargin"
                unit={unit}
                value={streamingPrice.salesMargin!}
                precision={2}
                isReadOnly
                tabIndex={1}
              />
            </VerticalFormGroup>
          </div>
        )}
      </div>
    </Block>
  );
}
